import { Game } from "@game/game";
import { CSSProperties, useEffect, useState } from "react";
import { THEME } from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    container: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0
    },
    list: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 6,
        minHeight: 0,
        overflowY: "auto"
    },
    row: {
        display: "flex",
        flexDirection: "column",
        padding: "6px 4px",
        borderBottom: "1px solid rgba(0,0,0,0.1)"
    },
    name: {
        ...THEME.text,
        fontWeight: "bold",
        fontSize: "medium"
    },
    nameLocked: {
        ...THEME.text,
        fontWeight: "bold",
        fontSize: "medium",
        opacity: 0.4
    },
    description: {
        ...THEME.text,
        fontSize: "small"
    },
    descriptionLocked: {
        ...THEME.text,
        fontSize: "small",
        opacity: 0.4
    }
};

interface IAchievement {
    id: string
    name: string
    description: string | null
    unlocked: boolean
    unlockedAt: number | null
}

interface IAchievementsTabPanel {
    game: Game
}

export function AchievementsTabPanel({ game }: IAchievementsTabPanel) {
    const [achievements, setAchievements] = useState<IAchievement[]>([]);

    useEffect(() => {
        game.getAchievements().then(r => setAchievements(r.results));
    }, []);

    const unlocked = achievements.filter(a => a.unlocked);
    const locked   = achievements.filter(a => !a.unlocked);

    return (
        <div style={styles.container}>
        <div style={styles.list}>
            {unlocked.map(a => (
                <div key={a.id} style={styles.row}>
                    <span style={styles.name}>{a.name}</span>
                    <span style={styles.description}>{a.description}</span>
                </div>
            ))}
            {locked.map(a => (
                <div key={a.id} style={styles.row}>
                    <span style={styles.nameLocked}>{a.name}</span>
                </div>
            ))}
        </div>
        </div>
    );
}
